// 材料ロット一覧テーブル(一覧Accordion内・出荷詳細の両方から使う共通テーブル)。

import { useNavigate } from "react-router-dom";
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import Time from "../../../util/Time";
import { DataLink, MasterLink } from "../../../components/links/EntityLinks";
import { LotStatusBuilder } from "../../../components/MaterialStatusBuilder";
import { carryOutRow } from "../../../schema/console/carry_out";
import { ConstituentsById, MaterialsById, activeLots, constituentsOf, isLotShipped, materialName } from "./helpers";
import { ReactNode } from "react";

export function materialLinkCell(materialsById: MaterialsById, materialId: number | null): ReactNode {
  if (materialId == null) {
    return "-";
  }
  return <MasterLink type="material" id={materialId} name={materialName(materialsById, materialId)} />;
}

export function LotTable({ co, materialsById, constituentsById, detailed = false }: { co: carryOutRow; materialsById: MaterialsById; constituentsById: ConstituentsById; detailed?: boolean }) {
  const navigate = useNavigate();
  const lots = activeLots(co);
  const colCount = detailed ? 8 : 7;
  return (
    <Box sx={{ overflowX: "auto" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>材料ロット</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>材料</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>LotNo</TableCell>
            {detailed && <TableCell sx={{ fontWeight: "bold" }}>製造日</TableCell>}
            <TableCell sx={{ fontWeight: "bold" }}>構成細目</TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="right">予定QR数</TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>状況</TableCell>
            <TableCell sx={{ fontWeight: "bold" }} align="center">QR読込</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lots.map((lot) => (
            <TableRow key={lot.id} hover>
              <TableCell><DataLink type="lot" id={lot.id} parentId={co.id} /></TableCell>
              <TableCell>{materialLinkCell(materialsById, lot.material_id)}</TableCell>
              <TableCell>{lot.lot_no ?? <Typography variant="caption" color="text.secondary">(LotNo未記録)</Typography>}</TableCell>
              {detailed && <TableCell>{lot.manufactured_at != null ? new Time(lot.manufactured_at).Format("YYYY/MM/dd") : "-"}</TableCell>}
              <TableCell><Typography variant="caption" color="text.secondary">{constituentsOf(constituentsById, lot.material_id) || "-"}</Typography></TableCell>
              <TableCell align="right">{lot.material_count}</TableCell>
              <TableCell>{LotStatusBuilder(lot, 14)}</TableCell>
              <TableCell align="center">
                <Button size="small" variant="outlined" onClick={() => navigate(`/console/carry-out/${co.id}/lot/${lot.id}/scan/`)}>
                  {isLotShipped(lot) ? "再読込" : `${lot.Materials.length}/${lot.material_count}`}
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {lots.length === 0 && (
            <TableRow><TableCell colSpan={colCount} align="center" sx={{ py: 2, color: "text.secondary" }}>ロット未登録</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
}
